module.exports = __webpack_public_path__ + "img/company_comfirm.a9301e33.svg";